import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import {MediciValidationsModalDispatchProps} from '../types/containers';
import MediciValidationsModalView from '../components/views/MediciValidationsModalView';

const mapStateToProps = (state: State) => {
    return {
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): MediciValidationsModalDispatchProps => {
    return {
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const MediciValidationsModalContainer = connect(
    mapStateToProps, mapDispatchToProps,
)(MediciValidationsModalView);

export default MediciValidationsModalContainer;
